import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { UnidadPageActions } from '../state/actions';
import { getViewModel, State } from '../state/unidad.selector';

@Component({
  selector: 'app-metas-modal',
  standalone: false,
  templateUrl: 'metas-modal.component.html',
  styleUrls: ['metas-modal.component.scss']
})
export class MetasModalComponent implements OnInit {

  vm$ = this.store.select(getViewModel);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: number,
    private store: Store<State>
  ) { }

  ngOnInit(): void {
    this.store.dispatch(UnidadPageActions.load({ tipo: "CriterioNormal" }));
    this.store.dispatch(UnidadPageActions.loadUnidadMetas({ idUnidad: this.data }));
}
}
